// One law for goal order everywhere (Paul, Nov 4 2026): a hand-set order
// first — dragged on the wall's chips — and alphabetical for any goal that
// was never dragged. Every surface that lists goals sorts with this, so the
// chip row, the goals page and every picker agree.
export const byGoalOrder = (a, b) =>
  ((a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER))
  || a.name.localeCompare(b.name);
